import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

// Языки подписаны на самих себе — так принято в переключателях языка.
const LANGUAGES = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
  { code: 'ro', label: 'Română' },
];

/**
 * Выпадающий список смены языка: глобус в верхней полосе, под ним — языки.
 * Выбор сохраняется обработчиком languageChanged в i18n.js (ключ «lng»).
 */
const LanguageMenu = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const current = LANGUAGES.find((lang) => lang.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    if (!open) return undefined;
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const select = (code) => {
    setOpen(false);
    if (code !== i18n.language) i18n.changeLanguage(code);
  };

  return (
    <div className="lang-menu" ref={wrapRef}>
      <button
        type="button"
        className={`lang-menu-trigger${open ? ' open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t('nav.languageSwitcher')}
      >
        <Icon name="globe" size={18} />
        <Icon name={open ? 'chevron-up' : 'chevron-down'} size={13} />
      </button>

      {/* Свой тултип вместо системного: тёмная плашка под кнопкой */}
      <span className="ui-tip" aria-hidden="true">{current.label}</span>

      {open && (
        <div className="lang-menu-list" role="menu">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              type="button"
              role="menuitemradio"
              aria-checked={lang.code === i18n.language}
              className={`lang-menu-item${lang.code === i18n.language ? ' active' : ''}`}
              onClick={() => select(lang.code)}
            >
              <span>{lang.label}</span>
              {lang.code === i18n.language && <Icon name="check" size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageMenu;
